import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { debounce, useStyles, usePrevious, useBoolean } from '@sravni/react-utils';
import { MaskInput, Space, Typography, FormControl, Button } from '@sravni/react-design-system';
import { Text as Text$1 } from '@sravni/react-design-system/lib/Typography';
import img from './assets/car~MxBCsyXV.png';
import axios from 'axios';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var useMediaInfo = function () {
    var _a = __read(useState({ isTablet: false, isPhone: false, isDesktop: true }), 2), mediaInfo = _a[0], setMediaInfo = _a[1];
    useEffect(function () {
        function update() {
            var isDesktop = window.matchMedia("(min-width: 980px)").matches;
            var isTablet = window.matchMedia("(min-width: 630px)").matches;
            var newInfo = {
                isPhone: !isDesktop && !isTablet,
                isTablet: !isDesktop && isTablet,
                isDesktop: isDesktop
            };
            if (newInfo.isTablet !== mediaInfo.isTablet ||
                newInfo.isPhone !== mediaInfo.isPhone ||
                newInfo.isDesktop !== mediaInfo.isDesktop) {
                setMediaInfo(newInfo);
            }
        }
        update();
        var debouncedUpdate = debounce(update, 150);
        window.addEventListener('resize', debouncedUpdate);
        return function () {
            window.removeEventListener('resize', debouncedUpdate);
        };
    }, [mediaInfo]);
    return mediaInfo;
};

var RusIcon = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "28", height: "20", fill: "none", className: className },
        React.createElement("rect", { width: "27.5", height: "19.5", x: ".25", y: ".25", fill: "#fff", stroke: "#DADDE2", strokeWidth: ".5", rx: "1.75" }),
        React.createElement("g", { fillRule: "evenodd", clipRule: "evenodd" },
            React.createElement("path", { fill: "#0C47B7", d: "M0 13.333h28V6.666H0v6.667Z" }),
            React.createElement("path", { fill: "#E53B35", d: "M0 20h28v-6.666H0V20Z" }))));
};

var rightLetters = __spreadArray([], __read('АВЕКМННОРСТУХавекмннорстухABEKMHHOPCTYXabekmnhopctyx'));
var digit = /\d/;
var letter = new RegExp("[" + rightLetters.join('') + "]");
var space = ' ';
var MASK_REGISTRATION_NUMBER = [
    letter,
    space,
    digit,
    digit,
    digit,
    space,
    letter,
    letter,
    space,
    space,
    digit,
    digit,
    digit,
];

var modules_0a2da23a = {"mask-input":"_1nsoo0g"};
/*SRAVNI__src/components/CarNumberInput/src/car-number-input.module.scss__SRAVNI*/;

var IconForInput = function () { return (React.createElement(Space, { direction: "horizontal", size: 8 },
    React.createElement(RusIcon, null),
    React.createElement(Text$1, { uppercase: true, strong: true, size: 16, className: "h-color-D80" }, "RUS"))); };
var maskPlaceholder = 'A 000 AA  000';
var CarNumberInput$1 = function (_a) {
    var handleEnterEvent = _a.handleEnterEvent, handleFocusEvent = _a.handleFocusEvent, loading = _a.loading, setValueAtParent = _a.setValue, className = _a.className;
    var cx = useStyles(modules_0a2da23a);
    var _b = __read(useState(''), 2), value = _b[0], setValue = _b[1];
    var formattedValue = useMemo(function () { return ("" + value).replace(/[\s_]/g, ''); }, [value]);
    var prevFormattedValue = usePrevious(formattedValue);
    var handleChange = useCallback(function (userValue) {
        setValue(userValue !== null && userValue !== void 0 ? userValue : '');
    }, []);
    useEffect(function () {
        if (prevFormattedValue === formattedValue) {
            return;
        }
        setValueAtParent(formattedValue);
    }, [formattedValue, prevFormattedValue, setValueAtParent]);
    var beforeMaskedStateChange = function (_a) {
        var nextState = _a.nextState;
        var value = nextState.value;
        var normalizedValue = __spreadArray([], __read(value.toUpperCase())).map(function (char) {
            if (!rightLetters.includes(char)) {
                return char;
            }
            var charIndex = rightLetters.indexOf(char);
            if (charIndex < rightLetters.length / 2) {
                return char;
            }
            var indexOfKirillChar = charIndex - rightLetters.length / 2;
            return rightLetters[indexOfKirillChar];
        })
            .join('');
        return __assign(__assign({}, nextState), { value: normalizedValue });
    };
    return (React.createElement(MaskInput, { disabled: loading, loading: loading, mask: MASK_REGISTRATION_NUMBER, onChange: handleChange, onKeyUp: handleEnterEvent, onFocus: handleFocusEvent, value: value, className: cx(className, 'mask-input'), icon: React.createElement(IconForInput, null), placeholder: maskPlaceholder, beforeMaskedStateChange: beforeMaskedStateChange }));
};

var texts = {
    title: 'Нужен ОСАГО?\nИдти в\u00A0офис не\u00A0обязательно!',
    subtitle: 'Введите госномер\u00A0— а мы\u00A0покажем предложения от\u00A017\u00A0страховых',
    button: 'Рассчитать'
};

var modules_98629b90 = {"container":"_abk1ic","container-phone":"_3syyj0","card":"_1pdn8fm","heading":"_a1113","subtitle":"_i39y55","form-control":"_1pe8txz","button":"_nudsug","image":"_1kvtf6g"};
import "./assets/CalculationWidgetForArticles.css";

var Heading = Typography.Heading, Text = Typography.Text, Link = Typography.Link;
var WidgetForArticles$1 = function (_a) {
    var error = _a.error, handleFocusEvent = _a.handleFocusEvent, handleSubmit = _a.handleSubmit, loading = _a.loading;
    var cx = useStyles(modules_98629b90);
    var isPhone = useMediaInfo().isPhone;
    var _b = __read(useState(''), 2), inputValue = _b[0], setInputValue = _b[1];
    var handleEnterEvent = useCallback(function (event) {
        if (event.keyCode === 13) {
            handleSubmit(inputValue);
        }
    }, [handleSubmit, inputValue]);
    return (React.createElement("div", { className: cx('container', { 'container-phone': isPhone }) },
        React.createElement(Space, { direction: "vertical", justify: "center", className: cx('card'), size: isPhone ? 16 : 12 },
            React.createElement(Space, { direction: "column", size: isPhone ? 8 : 4 },
                React.createElement(Heading, { className: cx('heading'), level: 4 }, texts.title),
                React.createElement(Text, { size: 14, className: cx('subtitle') }, texts.subtitle)),
            React.createElement(Space, { direction: isPhone ? 'vertical' : 'horizontal', size: isPhone ? 12 : 16, align: "center", className: cx('form-container') },
                React.createElement(FormControl, { invalid: !!error },
                    React.createElement(CarNumberInput$1, { handleEnterEvent: handleEnterEvent, handleFocusEvent: handleFocusEvent, loading: loading, setValue: setInputValue }),
                    React.createElement(FormControl.HelperText, null, error)),
                React.createElement(Button, { disabled: loading, onClick: function () { return handleSubmit(inputValue); }, variant: "primary", size: isPhone ? 60 : 52, className: cx('button'), block: isPhone }, texts.button)),
            React.createElement(Text, { size: 14, className: isPhone ? 'h-text-center' : '' },
                React.createElement(Link, { href: "/osago/anketa/", target: "_blank" }, "\u0423 \u043C\u0435\u043D\u044F \u043D\u0435\u0442 \u043D\u043E\u043C\u0435\u0440\u0430"))),
        React.createElement("div", { className: cx('image') },
            React.createElement("img", { alt: "", src: img.src }))));
};

var getRegNumberToken = function (regNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("/proxy-osagoinsurance/getregnumbertokenugc/?regNumber=" + regNumber)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 2:
                e_1 = _a.sent();
                throw new Error(e_1);
            case 3: return [2 /*return*/];
        }
    });
}); };

var carNumberRegex = /^[АВЕКМНОРСТУХABEKMHOPCTYX]\d{3}[АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{2,3}$/;
var carNumberValidator = function (value) {
    if (value === '') {
        return 'Поле не может быть пустым';
    }
    if (value && !carNumberRegex.test(value)) {
        return 'Номер авто введен неверно';
    }
    return undefined;
};

var CalculationWidgetForArticles = function (_a) {
    var onRedirect = _a.onRedirect;
    var _b = __read(useState(undefined), 2), validationError = _b[0], setValidationError = _b[1];
    var _c = __read(useBoolean(false), 2), loading = _c[0], setLoading = _c[1];
    var redirectToOsago = useCallback(function (param) {
        onRedirect(window.location.origin + "/osago/?" + param);
    }, [onRedirect]);
    var handleSubmit = useCallback(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var error, token;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    error = carNumberValidator(value);
                    setValidationError(error);
                    if (!(error === undefined)) return [3 /*break*/, 4];
                    setLoading.on();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getRegNumberToken(value)];
                case 2:
                    token = (_b.sent()).token;
                    // Redirect to vehicle
                    redirectToOsago("regNumberToken=" + token);
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    // Redirect to index
                    redirectToOsago("platenumber=" + value);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [setLoading, redirectToOsago]);
    var handleFocusEvent = useCallback(function () {
        setValidationError(undefined);
    }, []);
    return (React.createElement(WidgetForArticles$1, { error: validationError, handleFocusEvent: handleFocusEvent, handleSubmit: handleSubmit, loading: loading }));
};

export { CalculationWidgetForArticles };
